import flat from 'flat'
import ru from './ru'

export default {
  ru: flat(ru),
}
